<template lang="pug">
  CardView(
    v-if='artist'
    type='artist'
    :id='artist.id'
    :likes='artist.likes'
    :cover='artist.cover'
    :running='running'
    :title='artist.title || $l10n("NO_NAME")'
    :link='`/artists/${artist.id}`'
    @play='$emit("play")'
    @pause='$emit("pause")'
    @like='$emit("like")'
    @unlike='$emit("unlike")'
  )
</template>

<script>
import CardView from "@/components/CardView/CardView";

export default {
  name: "ArtistCardView",
  props: ["artist", "running"],
  components: {
    CardView
  }
};
</script>
